import type { ChainId } from "./types";

export const getChainInfo = ( chain: ChainId, ) => {
	switch( chain ) {
		case 1:
			return {
				name: "ethereum",
				label: "Ethereum",
			}
		case 18:
			return {
				name: "ethereum tenderley 8",
				label: "Ethereum Tenderley 8",
			}
		case 188:
			return {
				name: "ethereum tenderley 88",
				label: "Ethereum Tenderley 88",
			}
		case 42161: 
			return {
			 name: "arbitrum",
			 label: "Arbitrum",
			}
		case 421618: 
			return {
			 name: "arbitrum tenderley 8",
			 label: "Arbitrum Tenderley 8",
			}
			case 4216188:
			return {
				name: "arbitrum tenderley 88",
				label: "Arbitrum Tenderely 88",
			}
		default:
			throw new Error(`@bracket/addressbook - invalid chain ${chain}`);
	}

}
